import { RPCDocs, RPCs } from "../../../services/rpc.js";
import { rpc } from "../rpc-bridge.js";
import { checkDevicePermissions, getDevice } from "@therms/web-js";
import { Service } from "mvc-kit";
//#region src/modules/AuthWrapper2/services/AuthService.ts
var Platform = RPCDocs.Auth.SaveDeviceInfo.v1.Platform;
var AuthService = class extends Service {
	async authenticate(email, password) {
		const { rpcClient } = rpc();
		const { data } = await rpcClient.call(RPCs.Auth.Authenticate.v2, {
			email,
			password
		});
		return data;
	}
	async authenticateAsUser(loginPassToken, userId) {
		const { rpcClient } = rpc();
		const device = await getDevice();
		const { data } = await rpcClient.call("auth::authenticate-as-user", {
			device,
			loginPassToken,
			userId
		});
		return data;
	}
	async getIdentityInfo() {
		const { rpcService } = rpc();
		const { data } = await rpcService.Auth.GetIdentityInfo.v1.call();
		return data;
	}
	async refreshAuthToken() {
		const { rpcService } = rpc();
		const { data } = await rpcService.Auth.RefreshAuthToken.v1.call();
		return data;
	}
	async saveDeviceInfo(appInfo) {
		const { rpcService } = rpc();
		await checkDevicePermissions().catch((err) => {
			console.error("Error checking device permissions:", err);
		});
		await rpcService.Auth.SaveDeviceInfo.v1.call({
			app: {
				appName: appInfo.appName,
				appVersion: appInfo.appVersion,
				platform: Platform.Web
			},
			device: getDevice()
		});
	}
	async switchUserProfile(userId) {
		const { rpcService } = rpc();
		const { data } = await rpcService.Auth.SwitchUserProfile.v1.call({ userId });
		return data;
	}
	deAuthenticate() {
		const { rpcClient } = rpc();
		rpcClient.call("auth::de-authenticate").catch(() => {});
	}
	async requestResetPassword(email) {
		const { rpcClient } = rpc();
		await rpcClient.call(RPCs.Auth.RequestResetPassword.v1, { email });
	}
	async setNewPassword(newPassword, token) {
		const { rpcClient } = rpc();
		await rpcClient.call(RPCs.Auth.SetNewPassword.v1, {
			newPassword,
			passwordChangeToken: token
		});
	}
};
//#endregion
export { AuthService };

//# sourceMappingURL=AuthService.js.map